import { AxiosResponse } from "axios";
import { UploadCentreResponse } from "../models/upload.centre";
import API from "../api";

const ROUTE_NAME = "upload-centres";

const UploadCentreService = {
  async getItems(): Promise<AxiosResponse<UploadCentreResponse>> {
    return await API.get(`/${ROUTE_NAME}/`)
  },
  async postItemId(key: number){
    return API.post(`/${ROUTE_NAME}/uploaded/file`, { labelId: key })
  }
};

export default UploadCentreService;
